import { Head, Link, useForm } from "@inertiajs/react"
import type { FormEvent } from "react"

import AppLogo from "@/components/app-logo"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { signupCompletionPath } from "@/routes"

interface Props {
  email_address: string
}

export default function New({ email_address }: Props) {
  const { data, setData, post, processing, errors } = useForm({
    name: "",
  })

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    post(signupCompletionPath())
  }

  return (
    <>
      <Head title="Complete Your Profile" />

      <div className="vignette noise bg-bg-body flex min-h-screen items-center justify-center px-6 py-12">
        <div className="w-full max-w-md">
          <div className="mb-8 text-center">
            <Link href="/" className="inline-flex items-center justify-center">
              <AppLogo />
            </Link>
          </div>

          <div className="border-border bg-bg-card rounded-lg border p-8 shadow-lg">
            <h1 className="font-display mb-2 text-center text-2xl tracking-wide">
              One Last Thing
            </h1>

            <p className="text-bone-muted mb-6 text-center text-sm">
              What should we call you?
            </p>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="name">Your name</Label>
                <Input
                  id="name"
                  type="text"
                  value={data.name}
                  onChange={(e) => setData("name", e.target.value)}
                  placeholder="Jane Doe"
                  required
                  autoFocus
                  autoComplete="name"
                />
                {errors.name && (
                  <p className="text-red text-sm">{errors.name}</p>
                )}
              </div>

              <Button type="submit" className="w-full" disabled={processing}>
                Complete Setup
              </Button>
            </form>

            <p className="text-bone-muted mt-6 text-center text-sm">
              Signed in as {email_address}
            </p>
          </div>
        </div>
      </div>
    </>
  )
}
